import { DocumentReference } from '@angular/fire/firestore';
import { Role } from '../enums';

export class User {
  firstName = '';
  lastName = '';
  email = '';
  role: Role;
  loc: DocumentReference = null;

  constructor(firstName: string, lastName: string, email: string, role: Role, loc: DocumentReference) {
    this.firstName = firstName;
    this.lastName = lastName;
    this.email = email;
    this.role = role;
    this.loc = loc;
  }
}
